(function (Drupal) {
  Drupal.behaviors.scrollAnimation = {
    attach: function (context, settings) {
      // Select all paragraph elements
      const paragraphs = context.querySelectorAll('.paragraph--type--configurable-layout'); // Ensure .paragraph is your correct class or selector

      // Function to check if the element is in the viewport
      function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
      }

      // Function to apply animation when scrolling
      function checkParagraphs() {
        paragraphs.forEach(function (paragraph) {
          const triggerBottom = window.innerHeight * 0.9;
          const paragraphTop = paragraph.getBoundingClientRect().top;

          // Apply the animation if the paragraph is off-screen initially and scrolled into view
          if (paragraphTop < triggerBottom && !paragraph.classList.contains('visible')) {
            paragraph.classList.add('visible'); // Add the 'visible' class to trigger the CSS animation
          }
        });
      }

      // Initially check all paragraphs to set the starting state
      paragraphs.forEach(function (paragraph) {
        if (!isInViewport(paragraph)) {checkParagraphs
          paragraph.style.opacity = 0; // Ensure it's hidden if off-screen
        }
      });

      // Add event listener for scroll
      document.addEventListener('scroll', checkParagraphs);

      // Check visible paragraphs on page load.
      checkParagraphs()
    }
  };
})(Drupal);
